import { Skeleton, SkeletonProps } from '@chakra-ui/react'

export default function PSkeleton({ children, ...rest }: SkeletonProps) {
  return (
    <Skeleton
      startColor="#2766ad7c"
      endColor="#141225"
      fadeDuration={1}
      minH={['22px', '28px', '34px', '42px']}
      {...rest}
    >
      {children}
    </Skeleton>
  )
}
